import { useEffect, useState } from "react";
import api from "../../api/axios";

import AppLayout from "../../layouts/AppLayout";
import SettingCard from "../../components/SettingCard";

function Stock() {

    const [list, setList] = useState([]);
    const [selectedCode, setSelectedCode] = useState(null);
    const [filterLog, setFilterLog] = useState(null);

    useEffect(() => {

        load();

    }, []);

    const load = () => {

        api.get("/auto/search/candidate")

            .then(res => {

                setList(res.data);

            });

    };

    const showFilterLog = (stockCode) => {
        if (selectedCode === stockCode) {
            setSelectedCode(null);
            setFilterLog(null);
            return;
        }
        setSelectedCode(stockCode);
        setFilterLog(null);
        api.get(`/auto/search/candidate/${stockCode}/buy-filter`)
            .then((res) => setFilterLog(res.data && Object.keys(res.data).length ? res.data : null))
            .catch(() => setFilterLog(null));
    };

    const star = (score) => {

        if (score >= 90) return "★★★★★";

        if (score >= 80) return "★★★★☆";

        if (score >= 70) return "★★★☆☆";

        if (score >= 60) return "★★☆☆☆";

        return "★☆☆☆☆";

    };

    const scoreColor = (score) => {

        if (score >= 90) return "#2ecc71";

        if (score >= 80) return "#3498db";

        if (score >= 70) return "#f39c12";

        return "#888";

    };

    return (

        <AppLayout

            title="추천종목"

            subTitle="자동매매 후보"

        >

            <SettingCard title={`추천 후보 (${list.length})`}>

                <div
                    style={{
                        fontSize: 13,
                        color: "#666"
                    }}
                >

                    SearchEngine 분석 결과

                </div>

            </SettingCard>

            {

                list.map((item, index) => (

                    <SettingCard

                        key={item.stockCode}
                        onClick={() => showFilterLog(item.stockCode)}

                        title={`${index + 1}위  ${item.stockName}`}

                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >

                            <div>

                                <div
                                    style={{
                                        fontSize: 13,
                                        color: "#888"
                                    }}
                                >

                                    {item.stockCode}

                                </div>

                                <div
                                    style={{
                                        marginTop: 6,
                                        color: "#666",
                                        fontSize: 13
                                    }}
                                >

                                    {item.reason}

                                </div>

                            </div>

                            <div
                                style={{
                                    textAlign: "right"
                                }}
                            >

                                <div
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 24,
                                        color: scoreColor(item.score)
                                    }}
                                >

                                    {item.score}

                                </div>

                                <div
                                    style={{
                                        color: "#f1c40f",
                                        fontSize: 14
                                    }}
                                >

                                    {star(item.score)}

                                </div>

                            </div>

                        </div>

                        {selectedCode === item.stockCode && filterLog?.status === "REJECTED" && (
                            <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid var(--input-border)" }}>
                                <strong>매수 필터 결과</strong>
                                <div style={{ marginTop: 6, color: "#b54708" }}>{filterLog.finalReason}</div>
                                <div style={{ marginTop: 6, color: "#666", fontSize: 13 }}>{filterLog.filterDetail}</div>
                            </div>
                        )}

                    </SettingCard>

                ))

            }

        </AppLayout>

    );

}

export default Stock;
